export default "__VITE_ASSET__2b1wbjO5__"